import * as React from 'react';

import { TabIds } from '@containers/ProductDetailContainer/ProductDetail/model';

import { withConsumers } from '../../context/contextConfig';

import {
  TabSwitcherContext,
  ITabSwitcherProviderState,
} from './context/TabSwitcherContext';
import { ITabLinkProps } from './model';
import { LinkWrapper } from './styled';

const TabLinkComponent: React.FC<ITabLinkProps & ITabSwitcherProviderState> = ({
  setActiveTab,
  tabId,
  activeTabId,
  isDefaultTab,
  children,
  toggleIsReviewTabVisibleOnMobile,
}) => {
  const setActiveTabHandler = () => {
    setActiveTab(tabId);

    if (tabId === TabIds.Reviews) {
      toggleIsReviewTabVisibleOnMobile(true);
    }
  };

  const isActive: boolean =
    (typeof activeTabId === 'undefined' && isDefaultTab) ||
    activeTabId === tabId;

  /* eslint-disable react/jsx-no-useless-fragment */
  return typeof children === 'function' ? (
    <>
      {children({
        setActiveTab: setActiveTabHandler,
        isActive,
      })}
    </>
  ) : (
    <LinkWrapper onClick={setActiveTabHandler}>{children}</LinkWrapper>
  );
};

export const TabLink = withConsumers<ITabLinkProps, ITabSwitcherProviderState>(
  TabSwitcherContext.Consumer
)(TabLinkComponent);
